import React from "react";

/**
 * Pagination Component
 * @param {number} currentPage - Current page number (0-based)
 * @param {number} totalPages - Total number of pages
 * @param {function} onPageChange - Callback when page changes, receives 1-based page number
 */
const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const itemsPerBlock = 10; // 블록당 최대 페이지 버튼 수

  // 현재 블록 계산 (0-based currentPage를 1-based로 변환)
  const displayPage = currentPage + 1;
  const currentBlock = Math.floor((displayPage - 1) / itemsPerBlock);
  const blockStart = currentBlock * itemsPerBlock + 1;
  const blockEnd = Math.min((currentBlock + 1) * itemsPerBlock, totalPages);

  // 페이지 배열 생성
  const pages = [];
  for (let i = blockStart; i <= blockEnd; i++) {
    pages.push(i);
  }

  const handlePageClick = (page) => {
    onPageChange(page);
  };

  const handlePrevBlock = () => {
    if (currentBlock > 0) {
      const prevBlockLastPage = currentBlock * itemsPerBlock;
      onPageChange(prevBlockLastPage);
    }
  };

  const handleNextBlock = () => {
    if ((currentBlock + 1) * itemsPerBlock < totalPages) {
      const nextBlockFirstPage = (currentBlock + 1) * itemsPerBlock + 1;
      onPageChange(nextBlockFirstPage);
    }
  };

  if (totalPages <= 1) {
    return null; // 페이지가 1개 이하면 페이지네이션 표시 안 함
  }

  return (
    <nav aria-label="Page navigation">
      <ul className="pagination justify-content-center">
        {/* 이전 블록 버튼 */}
        <li className={`page-item ${currentBlock === 0 ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={handlePrevBlock}
            disabled={currentBlock === 0}
          >
            이전
          </button>
        </li>

        {/* 페이지 번호 버튼 */}
        {pages.map((page) => (
          <li key={page} className={`page-item ${displayPage === page ? "active" : ""}`}>
            <button
              className="page-link"
              onClick={() => handlePageClick(page)}
              aria-current={displayPage === page ? "page" : undefined}
            >
              {page}
            </button>
          </li>
        ))}

        {/* 다음 블록 버튼 */}
        <li className={`page-item ${(currentBlock + 1) * itemsPerBlock >= totalPages ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={handleNextBlock}
            disabled={(currentBlock + 1) * itemsPerBlock >= totalPages}
          >
            다음
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
